import { ComponentPropsWithoutRef } from 'react';

export function Tbody(props: ComponentPropsWithoutRef<'tbody'>) {
  return <thead {...props} />;
}
